import { types } from "./types";

export const mutations = {
  [types.UPDATE_VARIANT](state, option) {
    state.selectedVariant = { ...state.selectedVariant, ...option };
  },
};
